import { createConstants } from '../../../../hermes-redux';

export default createConstants(
  '@notifications/',
  'SET_TOTAL_NOTIFICATIONS_NUMBER',
  'FETCH_NOTIFICATIONS_PENDING',
  'FETCH_NOTIFICATIONS_SUCCESS',
);
